import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  deleteRestorePointsVapp(vdcId, vappId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/vapp/' + vappId + '/backups';
    return this.http
      .delete(url)
      .map(
        (res: any) => this.value = res
      );
  }

  deleteRestorePointsDeletedVapp(vdcId, vappId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/deletedVApp/' + vappId + '/backups';
    return this.http
      .delete(url)
      .map(
        (res: any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/delete-restore/delete-restore.service.ts